import {
  IAPIApplicationSettingsModel,
  IAPIPurchaseDomains,
} from "../interfaces";

export class ApplicationSettingsModel {
  purchaseDomains: PurchaseAllowedDomainsModel[];
  constructor(data?: Partial<ApplicationSettingsModel>) {
    this.purchaseDomains =
      data?.purchaseDomains?.map((d) => new PurchaseAllowedDomainsModel(d)) ||
      [];
  }

  static deserializeAPIModel(
    data: IAPIApplicationSettingsModel
  ): ApplicationSettingsModel {
    const mappedData: Partial<ApplicationSettingsModel> = {
      purchaseDomains: data?.purchaseDomains?.map((d) =>
        PurchaseAllowedDomainsModel.deserializeAPIModel(d)
      ),
    };
    return new ApplicationSettingsModel(mappedData);
  }
}

export class PurchaseAllowedDomainsModel {
  domain: string;
  constructor(data?: Partial<PurchaseAllowedDomainsModel>) {
    this.domain = (data && data.domain) || "";
  }

  static deserializeAPIModel(
    data: IAPIPurchaseDomains
  ): PurchaseAllowedDomainsModel {
    const mappedData: Partial<IAPIPurchaseDomains> = {
      domain: data?.domain || "",
    };
    return new PurchaseAllowedDomainsModel(mappedData);
  }
}
